export default "__VITE_ASSET__BTos3rPi__"